import axios from 'axios';
import moment from 'moment';
import { AppConfig, JWT } from '../config';
import { ServiceConstant } from './constants/ServiceConstant';
import { SERVICE_STATUS } from '../config/ServiceConstants';
import { ProgramConstant } from './constants/ProgramConstant';
import { AlertAction } from './AlertAction';
import { ServiceModalAction } from './ServiceModalAction';
// BUG-225: 사용자 안내 문구 i18n (CompanyAction 선례 — actions 레이어 Translate 사용)
import { Translate as t } from '../config/Translate';
import { store } from '../store';

const CreateService = (newservice) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	// BUG-225 (#443): 결과를 반환한다(성공 service / 실패 null) — 호출 컴포넌트
	// (현재 화면 호출처 없음 — 생성 양식은 CreateServiceLocal 사용)가 redux 참조 변화에만 의존하면 실패 시 로딩이 영구
	// 고정되므로, 반환값으로 해제를 판정한다. dispatch 부수효과는 기존 계약 그대로.
	let created = null;
	try {
		const user = JSON.parse(localStorage.getItem('user'));
		const data = {
			who: user.adminid,
			type: 'create',
			data: { ...newservice, ticketNationCode: user.companyInfo.country },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			created = ret.data.data;
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_CREATE, service: created });
		} else {
			// 리뷰 F-001: Error 인자는 {errmsg, errors} 를 가진 응답 원본(ret.data)이어야 하고
			// (기존 ret.data.err 는 항상 undefined → 무음), 순서는 GetServiceByTicketKey(M2)와 동일하게
			// Error 먼저 → 사용자 표시는 뒤따르는 ErrorMsg 가 담당.
			dispatch(AlertAction.Error(ret.data));
			dispatch(AlertAction.ErrorMsg(t('service.message.createFailed')));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg(t('service.message.createFailed')));
	}
	dispatch({ type: ServiceConstant.LOADED });
	return created;
};

const CreateServiceLocal = async (newservice) => {
	try {
		const user = JSON.parse(localStorage.getItem('user'));
		const data = {
			who: user.adminid,
			type: 'create',
			data: { ...newservice, ticketNationCode: user.companyInfo.country },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success')
			return ret.data.data;
	} catch (error) {
		console.warn('[ServiceAction.CreateServiceLocal] failed', {
			handler: 'ServiceAction.CreateServiceLocal',
			reason: error?.message || String(error),
		});
	}
	return null;
};

const GetServiceBySN = (sn) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/service/getbysn/' + sn, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_PRODUCT_GET_ALL, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to load services"));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const GetSearchServiceAll = async (searchCols, keyword) => {
	try {
		const data = {
			type: "get",
			data: {
				searchCols: searchCols, //[ 'sitename', 'customerFirstName', 'customerLastName' ],
				searchKey: keyword
			}
		}
		return await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
	} catch (error) {
		return null;
	}
};

const GetSearchServiceByAtlasSearch = async (keyword) => {
	try {
		const aggregate = [];
		aggregate.push({
			'$search': {
				'index': 'rayguard-service',
				'text': {
					'query': keyword,
					'path': {
						'wildcard': '*' // "path": ["title", "content"],  // 검색할 필드들
						//"score": { "boost": { "value": 2, "path": "title" } }  // 제목 필드에 가중치 부여
					}
				}
			}
		},{
			'$addFields': {
				'score': { '$meta' : 'searchScore' }
			}
		},{
			'$sort': {
				'score': -1
			}
		},{
			'$limit': 20
		});
		aggregate.push({
			'$lookup' : {
				'from': 'products',
				'localField': 'sn',
				'foreignField': 'sn',
				'as': 'prds'
				}
		});
		aggregate.push({
			'$project': {
				'createDate' : 1,
				'ticketKey' : 1,
				'status' : 1,
				'summary' : 1,
				'updateDate' : 1,
				'assignee' : 1
			}
		});
		const data = {
			data : {
				type: "service",
				aggregate,
				passfilter: true,
			}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());

		//const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			return ret;
		}
		return null;
	} catch (error) {
		return null;
	}
}

const GetServiceAll = (filter, append = false) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const showmodel = store.getState().ProgramReducer.showmodel;
		const data = showmodel[0] !== '' ?
			{ type: "get", data: {...filter, match : {...filter.match, model : { '$in' : showmodel }} } } :
			{ type: "get", data: filter}

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_GET_ALL, result: ret.data.data, append });
			dispatch({
				type: ProgramConstant.SET_SEARCHSCREEN_TITLE,
				title: "Services",
				count: ret.data.data.totalcount
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to load services"));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const GetServiceOpenCount = async () => {
	try {
		const showmodel = store.getState().ProgramReducer.showmodel;
		const aggregate = [];
		aggregate.push({ '$match': { 'status': { "$ne": SERVICE_STATUS.CLOSE } } });
		if(showmodel[0] !== ''){
			aggregate.push({
				'$lookup' : {
					'from': 'products',
					'localField': 'sn',
					'foreignField': 'sn',
					'as': 'prds'
				  }
			})
			aggregate.push({
				'$match' : {
					'prds' : {
						'$elemMatch' : {
							'model' : { '$in' : showmodel}
						}
				  	}
				}
			});
		}
		aggregate.push({
			'$project': {
				'createDate' : 1,
				'ticketKey' : 1,
				'status' : 1,
				'summary' : 1,
				'updateDate' : 1,
				'assignee' : 1
			}
		});
		const data = {
			data : {
				type: "service",
				aggregate,
			}
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/q', data, JWT());

		//const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
		return null;
	} catch (error) {
		return null;
	}
	// const data = { type: "getopenCount" }
	// const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
	// if (ret.data.status == 'success') {
	// 	return ret.data.data;
	// }
	// return null
};

const GetFavServiceAll = (filter) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const uData = JSON.parse(localStorage.getItem('user'));
		const data = {
			type: "get",
			data: { ...filter, match: { ticketKey: { '$in': uData.favoriteServices } } }
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_GET_ALL, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to load favorite services"));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const SearchService = async (filter) => {
	try {
		const data = { type: "get", data: filter }
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		}
		return [];
	} catch (error) {
		return [];
	}
};

const GetServiceAllLocal = async (filter) => {
	try {
		const data = { type: "get", data: filter }
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());

		if (ret.data.status == 'success') {
			return ret.data.data;
		}
	} catch (error) {
		// silent — caller handles undefined
	}
};

const GetService = (_id) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/service/' + _id, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_GET_ONE, service: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to load service"));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const GetServiceByTicketKey = (ticketKey) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	// F-006→F-021: 실패 시 전역 CLEAER 는 경합에 취약 — B 조회가 늦게 실패하는 사이
	// 사용자가 A 로 이동해 정상 로드되면, 뒤늦은 B 실패의 CLEAER 가 A 를 지운다.
	// 그래서 CLEAER 는 "자기 화면 재조회 실패"(redux 의 현재 티켓 == 요청 티켓)이거나
	// 아직 아무 티켓도 없을 때만 수행한다(빈 상태 CLEAER 는 무해한 초기화).
	// 다른 티켓이 로드돼 있으면 skip — stale 렌더는 ServiceDetail/AdminServiceInfo 의
	// 라우트 게이트(ticketKey 일치 시에만 렌더)가 분담 차단한다.
	const clearIfSameTicket = () => {
		const currentTicketKey = store.getState()?.ServiceReducer?.service?.ticketKey;
		if (!currentTicketKey || currentTicketKey === ticketKey) {
			dispatch({ type: ServiceConstant.CLEAER });
		} else {
			// §7 No Silent Drop: 가드 skip 은 관측 가능해야 한다.
			console.warn('[ServiceAction.GetServiceByTicketKey] CLEAER skipped', {
				handler: 'ServiceAction.GetServiceByTicketKey',
				requestedTicketKey: ticketKey,
				currentTicketKey,
				reason: 'another ticket already loaded in redux — route gate blocks stale render (F-021)',
			});
		}
	};
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/service/getbyticket/' + ticketKey, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_GET_ONE, service: ret.data.data });
		} else {
			// BUG-225 (#443): BE 가 errors 없이 실패(EP0009 등)를 주면 Error(ret.data) 는
			// message=[] 로 저장돼 토스트 조건([] == "")에서 무음이었다 — 항상 안내를 띄운다.
			// 화면은 전 필드 N/A 로 남으므로(BUG-224 러시아 사례) 이 토스트가 유일한 신호다.
			// 리뷰 M2: Error 를 먼저 dispatch — ERROR 는 message 를 비우므로(리듀서가 errmsg 를 버림)
			// 사용자 표시는 뒤따르는 ErrorMsg 가 담당한다.
			// F-006: 자기 화면 재조회 실패 시 잔존분을 비워 wrong-record write 차단 (경합 시 skip — 위 F-021 주석).
			clearIfSameTicket();
			console.warn('[ServiceAction.GetServiceByTicketKey] load failed', { ticketKey, errmsg: ret?.data?.errmsg });
			dispatch(AlertAction.Error(ret.data));
			dispatch(AlertAction.ErrorMsg(t('service.message.loadFailed')));
		}
	} catch (error) {
		// F-006: 자기 화면 재조회 실패 시 잔존분을 비워 wrong-record write 차단 (경합 시 skip — 위 F-021 주석).
		clearIfSameTicket();
		console.warn('[ServiceAction.GetServiceByTicketKey] load failed', { ticketKey, error: error?.message });
		dispatch(AlertAction.ErrorMsg(t('service.message.loadFailed')));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const UpdateService = (serviceId, serviceInfo) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	let ok = false;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'update',
			data: serviceInfo,
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
	return ok;
};

const SendMail = (serviceId, mailData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'sendMail',
			data: mailData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.mailSent')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const UpdateAssignee = (serviceId, assignData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	let ok = false;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateAssignee',
			data: assignData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
	return ok;
};

const UpdateStatusBulk = (serviceIds, statusData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'statusUpdateBulk',
			list: serviceIds,
			data: statusData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO_BULK, services: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const UpdateStatus = (serviceId, statusData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	let ok = false;
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'statusUpdate',
			data: statusData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
	return ok;
};

const Comment = (serviceId, type, commentData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: type,
			data: commentData
		};

		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(/^del/i.test(String(type)) ? t('common.message.deleted') : t('common.message.success.saved')));
			dispatch({ type: type == "ADD" ? ServiceConstant.SERVICE_UPDATE_INFO : ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const Replacement = (serviceId, type, replacementData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: type == "ADD" ? "addReplacement" : "delReplacement",
			data: replacementData
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(type == "ADD" ? t('common.message.success.saved') : t('common.message.deleted')));
			dispatch({
				type: type == "ADD" ?
					ServiceConstant.SERVICE_UPDATE_INFO :
					ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const Attachment = (serviceId, type, attachmentData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: type == "ADD" ? "addAttachment" : "delAttachment",
			data: attachmentData
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(type == "ADD" ? t('common.message.success.saved') : t('common.message.deleted')));
			dispatch({
				type: type == "ADD" ?
					ServiceConstant.SERVICE_UPDATE_INFO :
					ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data
			});
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const UpdateSig = (serviceId, sigData) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'updateSignature',
			data: sigData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const MoveTrash = (serviceId) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'trash'
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_INFO, service: ret.data.data });
			// BE가 await로 Alert 정리 완료 후 응답하므로 재조회 시 정리된 상태 반영
			dispatch(ServiceModalAction.GetPendingAlerts());
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const Delete = (delserviceId) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'delete'
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + delserviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: ServiceConstant.SERVICE_DELETE, delserviceId: delserviceId });
			// BE가 await로 Alert 정리 완료 후 응답하므로 재조회 시 정리된 상태 반영
			dispatch(ServiceModalAction.GetPendingAlerts());
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const DeleteSimple = async (delserviceId) => {
	try {
		const data = {
			who: JSON.parse(localStorage.getItem('user')).adminid,
			type: 'delete'
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + delserviceId, data, JWT());
		if (ret.data.status == 'success') {
			return true;
		}
	} catch (error) {
		// silent — caller handles falsy return
	}
	return false;
};

const UpdatePriority = (serviceId, priority, who) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const data = {
			who,
			type: 'updatePriority',
			data: { priority },
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service/' + serviceId, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: ServiceConstant.SERVICE_UPDATE_PRIORITY, service: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const AddUpdate = (info) => async (dispatch) => {
	dispatch({ type: ServiceConstant.ADDUPDATE, item: info });
};

const ClearUpdateResult = () => (dispatch) => {
	dispatch({ type: ServiceConstant.SERVICE_CLEAR_UPDATERES });
};

const GetReducer = (state) => {
	return state.ServiceReducer;
};


const GetAllHomeOverdueByFilter = (days) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const fin = days > 0 ? moment.utc(moment().utc()).add(-1 * days, 'days').unix() * 1000 : 4102444800000;
		const data = {
			type: "get",
			data: {
				match: {
					createDate: { '$lte': fin },
					status: { '$ne': SERVICE_STATUS.CLOSE },
					isDel: false
				}
			},
		}
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/service', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ProgramConstant.SET_OVERDUE_SERVICE, list: ret.data.data.list });
		}
	} catch (error) {
		// silent — overdue badge update failure is non-critical
	}
	dispatch({ type: ServiceConstant.LOADED });
};

const GetForExport = async (serviceId) => {
	try {
		return await axios.get(AppConfig.API_SERVER_PATH + '/service/getbyticket/' + serviceId, JWT());
	} catch (error) {
		return null;
	}
};

const GetServiceReplacementsBySN = (sn) => async (dispatch) => {
	dispatch({ type: ServiceConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/service/getreplacements/' + sn, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: ServiceConstant.SERVICE_GET_REPLACEMENTS, result: ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.ErrorMsg("Failed to load replacements"));
	}
	dispatch({ type: ServiceConstant.LOADED });
};

export const ServiceAction = {
	CreateService,
	CreateServiceLocal,
	GetServiceAll,
	GetFavServiceAll,
	GetService,
	GetServiceByTicketKey,
	UpdateService,
	SendMail,
	UpdateStatus,
	UpdateAssignee,
	Replacement,
	Attachment,
	UpdateSig,
	AddUpdate,
	Comment,
	MoveTrash,
	Delete,
	DeleteSimple,
	ClearUpdateResult,
	SearchService,
	GetReducer,
	GetServiceOpenCount,
	GetAllHomeOverdueByFilter,
	GetServiceBySN,
	GetSearchServiceAll,
	UpdateStatusBulk,
	GetForExport,
	GetServiceAllLocal,
	GetServiceReplacementsBySN,
	GetSearchServiceByAtlasSearch,
	UpdatePriority
};
